<template>
  <div>
    <SuccessfulResponse
      v-if="saveStatus"
      :type="type"
      :attestationCheck="attestationCheck"
      @close="$emit('close')"
    />
    <ErrorResponse
      v-else-if="errorLoadingParameters"
      :errorLoadingParameters="errorLoadingParameters"
      @close="$emit('close')"
      @retry="$emit('retry')"
    />
    <DuplicateResponse
      v-else-if="hasDuplicateName"
      :type="type"
      @close="$emit('close')"
      @change-name="$emit('change-name')"
    />
    <FailureResponse v-else @close="$emit('close')" @save="$emit('save')" />
  </div>
</template>

<script>
import SuccessfulResponse from '@/components/schedulerModal/schedulerSaveResponses/SuccessfulResponse'
import FailureResponse from '@/components/schedulerModal/schedulerSaveResponses/FailureResponse'
import ErrorResponse from '@/components/schedulerModal/schedulerSaveResponses/ErrorResponse'
import DuplicateResponse from '@/components/schedulerModal/schedulerSaveResponses/DuplicateResponse'

export default {
  name: 'SaveResponseMessage',
  components: {
    SuccessfulResponse,
    FailureResponse,
    DuplicateResponse,
    ErrorResponse,
  },
  props: {
    saveStatus: Boolean,
    hasDuplicateName: Boolean,
    errorLoadingParameters: Boolean,
    attestationCheck: Boolean,
    type: {
      type: String,
      default: 'feed',
    },
  },
}
</script>
